import { call, put, select } from 'redux-saga/effects';
import { PRODUCTS_COMPARE_MANAGE } from '../../actions';
import { getUnifiedCompareData } from '../../selectors/base';
import { UnifiedCompareState, ProductErrorState, ApiError } from '../../types';
import { deleteList } from '../../api';
import { removeGroupFromState, isDataSyncError, handleBadRequestError, SagaParams } from './utils';

const ERROR_MESSAGES = {
  DELETE_LIST_ERROR: 'Ошибка удаления списка',
} as const;

/**
 * NOTE: Сага для удаления списка сравнения
 * Удаляет список с сервера и обновляет локальное состояние
 */
export function* deleteListSaga(params: SagaParams): Generator {
  const currentState: UnifiedCompareState = yield select(getUnifiedCompareData);
  try {
    const { customerId, host, abortController, groupId } = params;

    yield call(deleteList, customerId, groupId, host, abortController.token);

    const updatedState = removeGroupFromState(currentState, groupId);

    yield put(PRODUCTS_COMPARE_MANAGE.success(updatedState));
  } catch (error) {
    const err = error instanceof Error ? error : new Error(ERROR_MESSAGES.DELETE_LIST_ERROR);

    if (isDataSyncError(error as ApiError)) {
      yield* handleBadRequestError();
    }

    const errorState: ProductErrorState = {
      error: err,
      productId: params.productId,
      groupId: params.groupId,
      currentState,
    };

    yield put(PRODUCTS_COMPARE_MANAGE.failure(errorState));
  }
}
